import cn from '@integrations/classnames'
import type { HTMLAttributes } from '@integrations/react'
import styles from './StatusBadge.module.scss'

type StatusBadgeTone = 'success' | 'warning' | 'error' | 'brand' | 'action' | 'neutral'

type Props = HTMLAttributes<HTMLSpanElement> & {
  tone?: StatusBadgeTone
  /** `false` renders a plain label chip (e.g. a role) without the leading status dot. */
  dot?: boolean
}

function StatusBadge({ children, className, tone, dot = true, ...props }: Props) {
  return (
    <span
      className={cn(
        styles['status-badge'],
        'status-badge',
        tone && styles[tone],
        tone && `status-badge-${tone}`,
        { [styles['plain']]: !dot, 'status-badge-plain': !dot },
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}

export type { StatusBadgeTone }
export default StatusBadge
